import React from 'react';
import PropTypes from 'prop-types';
import Text from '@/components/ui/Text';
import styles from './HorizontalScrollMenu.module.scss';

interface MenuItemProps {
  ariaControlId?: string;
  onClick: (text: string, event: React.MouseEvent<HTMLButtonElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
  selected: boolean;
  text: string;
}

// AIDEV-NOTE: PLAT-17624 — aria-controls is unconditional. It was selected-only because PLAT-17431
// was stripping references to dialogs absent from the DOM at rest; a SectionTabs panel is always in
// the DOM (the inactive one is only `tw-hidden`), so pointing at it always is correct — and the
// attribute is what SectionTabs' arrow-key handler uses to tell tabs from the scroll library's own
// arrow buttons.
const MenuItem = ({ ariaControlId, onClick, onKeyDown, selected, text }: MenuItemProps) => (
  <button
    aria-controls={ariaControlId}
    aria-current={selected ? 'true' : undefined}
    className={`${styles.menuItem} ${selected ? styles.active : ''}`}
    type="button"
    onClick={event => onClick(text, event)}
    onKeyDown={onKeyDown}
  >
    <Text size="sm" variant="body" weight="semibold">{text}</Text>
  </button>
);

MenuItem.propTypes = {
  ariaControlId: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  selected: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
};

MenuItem.defaultProps = {
  ariaControlId: null,
  onKeyDown: null,
};

export default MenuItem;
